/**
 * Whether this Mac is signed in to Mod (RFC 0337).
 *
 * The desktop shell reports it with the daemon's status: the Mod login the
 * daemon would present to the llm-proxy, which is what voice and Mod's own
 * models need. Outside the shell nothing reports, and the hook returns
 * undefined, which callers read as "cannot tell" and leave the feature shown.
 */

import { useEffect, useState } from 'react'

const STATUS_GLOBAL = '__modDaemonStatus'
const STATUS_EVENT = 'mod:daemon-status'

function readSignedIn(detail?: unknown): boolean | undefined {
  const status =
    detail ?? (globalThis as unknown as Record<string, unknown>)[STATUS_GLOBAL]
  const signedIn = (status as { signedIn?: unknown } | undefined)?.signedIn
  return typeof signedIn === 'boolean' ? signedIn : undefined
}

export function useMacSignedIn(): boolean | undefined {
  const [signedIn, setSignedIn] = useState<boolean | undefined>(() =>
    readSignedIn(),
  )
  useEffect(() => {
    const onStatus = (e: Event) =>
      setSignedIn(readSignedIn((e as CustomEvent<unknown>).detail))
    window.addEventListener(STATUS_EVENT, onStatus)
    setSignedIn(readSignedIn())
    return () => window.removeEventListener(STATUS_EVENT, onStatus)
  }, [])
  return signedIn
}
